import _ from "lodash";
export const getExportTypeIndex = ({ exportOptions, exportType }) => {
  const exportTypeIndex = _.findIndex(exportOptions, ["value", exportType]);

  return exportTypeIndex === -1 ? 0 : exportTypeIndex;
};
